import Token from "@routes/providers/token";
import User from "@routes/providers/user";

const RoutesWrapper = ({ children }) => {
    return (
        <Token>
            <User>{children}</User>
        </Token>
    );
};

export default RoutesWrapper;
